export const useConversionEvent =
    () =>
        ({ type = 'event', eventName = '', data = '' }) => {
            if (window.gtag) {
                window.gtag(type, eventName, data);
            }
        };
